import { render, staticRenderFns } from "./LogoSection.vue?vue&type=template&id=afee9dca"
import script from "./LogoSection.vue?vue&type=script&lang=js"
export * from "./LogoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports